import { CreditBookmark, CreditType } from 'types/credit';

import { ReferenceData } from 'types/reference-data';

export function isBookmarkValid(bookmark: CreditBookmark, referenceData: ReferenceData): boolean {
  return bookmark.creditType === CreditType.ARTICULATION
    ? referenceData.articulations.has(bookmark.creditItemID)
    : referenceData.precedents.has(bookmark.creditItemID);
}
